module.exports = "../images/cabin-4-person-1.jpg?v=51bbf00";